/**
 * Simple cache utility for chart data to prevent duplicate API calls
 */

const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

class ChartCache {
  constructor() {
    this.cache = new Map();
  }

  generateKey(submissionId, companyDomain, isPortfolio, isPublic) {
    if (isPortfolio) return 'portfolio';
    if (companyDomain) return `company-${companyDomain}`;
    if (isPublic) return `public-${submissionId}`;
    return `admin-${submissionId}`;
  }

  get(submissionId, companyDomain, isPortfolio, isPublic) {
    const key = this.generateKey(submissionId, companyDomain, isPortfolio, isPublic);
    const cached = this.cache.get(key);
    
    if (!cached) return null;
    
    // Check if cache is expired
    if (Date.now() - cached.timestamp > CACHE_TTL) {
      this.cache.delete(key);
      return null;
    }
    
    console.log(`Cache hit for key: ${key}`);
    return cached.data;
  }

  set(submissionId, companyDomain, isPortfolio, isPublic, data) {
    const key = this.generateKey(submissionId, companyDomain, isPortfolio, isPublic);
    this.cache.set(key, {
      data,
      timestamp: Date.now()
    });
    console.log(`Cached data for key: ${key}`);
  }

  clear() {
    this.cache.clear();
    console.log('Chart cache cleared');
  }

  // Clear cache for specific patterns (e.g., when new data is submitted)
  invalidatePattern(pattern) {
    const keysToDelete = [];
    for (const key of this.cache.keys()) {
      if (key.includes(pattern)) {
        keysToDelete.push(key);
      }
    }
    keysToDelete.forEach(key => this.cache.delete(key));
    console.log(`Invalidated cache for pattern: ${pattern}, removed ${keysToDelete.length} entries`);
  }
}

// Create singleton instance
const chartCache = new ChartCache();

// Export singleton instance
export default chartCache;